import React, { FC } from 'react';
import { colors } from 'styles/colors';
import TypographyWithI18N, {
  TypographyWithI18NProps,
} from 'shared/components/TypographyWithI18N';

interface IRecentHiringActivityChipProps extends TypographyWithI18NProps {
  chipVariant?: 'primary' | 'secondary';
}

const RecentHiringActivityChip: FC<IRecentHiringActivityChipProps> = ({
  chipVariant = 'primary',
  id,
  ...props
}) => {
  return (
    <TypographyWithI18N
      id={id}
      data-testid={id}
      component='span'
      {...props}
      className={
        chipVariant === 'secondary' ? 'kfic2-metadata' : 'kfic2-bodyTextSmall'
      }
      sx={{ 
        borderRadius: (theme: { typography: { pxToRem: (value: number) => string } }) => theme.typography.pxToRem(18),
        backgroundColor: colors.chip[chipVariant],
        display: 'inline-block',
        lineHeight: (theme: { typography: { pxToRem: (value: number) => string } }) =>
          `${theme.typography.pxToRem(
            chipVariant === 'secondary' ? 14 : 17
          )} !important`,
        p: '0.25rem 0.5rem',
      }}
    />
  );
};

export default RecentHiringActivityChip;
